import * as React from 'react'
import Link from 'gatsby-link'

// Please note that you can use https://github.com/dotansimha/graphql-code-generator
// to generate all types from graphQL schema
interface IndexPageProps {
  data: {
    site: {
      siteMetadata: {
        title: string
      };
    };
    allSitePage: {
      edges: Array<{
        node: {
          id: string;
          path: string;
        };
      }>;
    };
    allMarkdownRemark: {
      edges: Array<{
        node: {
          id: string;
          frontmatter: { title: string; permalink: string; date: string; };
          excerpt: string;
        };
      }>;
    };
  };
}

export default class extends React.Component<IndexPageProps, {}> {
  constructor(props: IndexPageProps, context: any) {
    super(props, context)
  }
  public render() {
    return (
      <div className='row align-center varnerinfo-content'>
        <div className="column small-12 medium-8">
          <table className='unstriped no-border'>
            <tbody>
              {this.props.data.allMarkdownRemark.edges.map(({ node }) => (
                <tr key={node.id}>
                  <td><small>{node.frontmatter.date}</small></td>
                  <td ><Link to={node.frontmatter.permalink}>{node.frontmatter.title}</Link></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }
    allSitePage {
      edges {
        node {
          id
          path
        }
      }
    }
    allMarkdownRemark(sort: {order: DESC, fields: [frontmatter___date]}) {
      edges {
        node {
          id
          frontmatter {
            title
            permalink
            date(formatString: "YYYY-MM-DD")
          }
          excerpt
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.tsx